import React from 'react';

import { Button, FileUpload, Modal } from '@unimed-fesp/components';

import { ModalContent, ModalContentWrapper } from '../../molecules/Modal';
import { Container, ContentFile, ContentText } from './styles';

function ModalFileLoading({
  isOpen,
  finishedLoadingFiles,
  isSuccess,
  files,
  onClickCancel,
  loading,
}) {
  return (
    <Modal
      width={600}
      height={473}
      isOpen={isOpen}
      onClick={() => onClickCancel(files)}
      disabled={loading}
      header={<>importar</>}
      footer={
        <ModalFooter
          loading={loading}
          onClickCancel={onClickCancel}
          files={files}
          isSuccess={isSuccess}
          finishedLoadingFiles={finishedLoadingFiles}
        />
      }
      justifyContentFooter="flex-end"
    >
      <ModalContentWrapper height="300" display="block">
        <ModalContent>
          <Container>
            <ContentText>
              Aguarde! Seus arquivos estão sendo carregados.
            </ContentText>
            {Object.values(files).map((file) => (
              <MyContentFile file={file} onClickCancel={onClickCancel} />
            ))}
          </Container>
        </ModalContent>
      </ModalContentWrapper>
    </Modal>
  );
}

const MyContentFile = ({ file, onClickCancel }) => {
  return (
    <ContentFile key={file.id}>
      <FileUpload
        fileName={file.name}
        fileSize={file.readableSize}
        uploadProgress={file.progress}
        onClickCancel={onClickCancel}
        file={file}
      />
    </ContentFile>
  );
};

const ModalFooter = ({
  loading,
  onClickCancel,
  files,
  isSuccess,
  finishedLoadingFiles,
}) => {
  return (
    <>
      <Button
        tipo="secondary"
        justifyCenter
        alignCenter
        disabled={loading}
        marginRight={20}
        font="16px unimed_slabregular"
        width={100}
        onClick={() => onClickCancel(files)}
      >
        cancelar
      </Button>

      <Button
        tipo="primary"
        justifyCenter
        alignCenter
        disabled={!isSuccess}
        opacity={!isSuccess ? 0.4 : 1}
        font="16px unimed_slabregular"
        width={100}
        onClick={finishedLoadingFiles}
        gap={10}
      >
        importar
      </Button>
    </>
  );
};

export default ModalFileLoading;
